import { Button } from '@mui/material';
import { useFormikContext } from 'formik';
import React, { memo, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { ResourceManagerRule, RuleConsequenceCreateObject } from '../../../backend';

export const CreateResourceScore = memo(
    ({ defaultConsequence, toggle }: { defaultConsequence: boolean; toggle: () => void }) => {
        const { setValues } = useFormikContext<ResourceManagerRule>();

        const handleClick = useCallback(() => {
            toggle();
            if (defaultConsequence) {
                setValues(o => ({
                    ...o,
                    consequence: null,
                }));
            } else {
                setValues(o => ({
                    ...o,
                    consequence: {
                        type: 'RuleConsequenceCreateObject',
                        objectType: 'ResourceScore',
                        objectFields: {
                            flight: { type: 'VariableFieldOperand', variable: '', field: 'id' },
                            resource: { type: 'TextOperand', value: '' },
                            rule: { type: 'TextOperand', value: '' },
                            score: { type: 'NumberOperand', value: 0 },
                        },
                    } as RuleConsequenceCreateObject,
                }));
            }
        }, [defaultConsequence, setValues, toggle]);

        return (
            <Button
                sx={{
                    color: 'white',
                    border: '0.2px solid white',
                    width: 'fit-content',
                    borderRadius: '2px',
                }}
                onClick={handleClick}
            >
                {defaultConsequence ? (
                    <FormattedMessage id={'ruleeditor.consequence.empty'} />
                ) : (
                    <FormattedMessage id={'ruleeditor.consequence.createobject'} />
                )}
            </Button>
        );
    },
);
